import { useState } from 'react';
import { Box } from '@mui/material';
import { TextField, Button } from '@qrios/frontend-library';

import Divider from '../divider/divider';
import { DetailsType } from '../details-list/interface';

interface Props {
  handleSearch: (operationId: string) => void;
  isSearching: boolean;
  error?: string;
  detailsType?: DetailsType;
}

const Search = ({ handleSearch, isSearching, error, detailsType }: Props) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const searchText = detailsType === 'operation' ? 'Operation Id' : 'Session Id';

  return (
    <Box component="form" display="flex" flexDirection="column">
      <Box display="flex" alignItems="flex-end" data-testid="search-form-content">
        <Box flex={5} mr={2}>
          <TextField
            data-testid="input-operation-id"
            handleChange={e => {
              setSearchValue(e.target.value);
            }}
            handleBlur={() => {}}
            name="name"
            label={searchText}
            value={searchValue}
            placeholder={`Enter ${searchText}`}
            error={error}
            touched={!isSearching}
          />
        </Box>
        <Box flex={2} mb={error && !isSearching ? 5 : 2}>
          <Button
            loading={isSearching}
            disabled={!searchValue}
            data-testid="button-next"
            size="large"
            type="submit"
            fullWidth={true}
            text="Next"
            onClick={e => {
              e.preventDefault();
              handleSearch(searchValue);
            }}
          />
        </Box>
      </Box>
      <Divider />
      <Box>{`Provide ${searchText} to get information about it.`}</Box>
    </Box>
  );
};

export default Search;
